'use client';

import * as React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { DayPicker } from 'react-day-picker';

import { cn } from '../../lib/utils';
import { buttonVariants } from './button';

function Calendar({
  className,
  classNames,
  showOutsideDays = false,
  numberOfMonths = 1,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      numberOfMonths={numberOfMonths}
      className={cn('p-3', className)}
      classNames={{
        months: 'flex gap-8 relative',
        month: 'flex flex-col gap-4',
        month_caption: 'flex justify-center relative items-center h-10',
        caption_label: 'text-sm font-semibold',
        nav: 'flex items-center justify-between absolute inset-x-0 top-0 z-10',
        button_previous: cn(
          buttonVariants({ variant: 'outline' }),
          'size-8 bg-transparent p-0 opacity-60 hover:opacity-100'
        ),
        button_next: cn(
          buttonVariants({ variant: 'outline' }),
          'size-8 bg-transparent p-0 opacity-60 hover:opacity-100'
        ),
        weekday: 'text-muted-foreground font-medium text-xs w-10 text-center',
        weekdays: 'flex',
        week: 'flex w-full mt-1',
        day: 'h-10 w-10 text-center text-sm p-0 relative flex items-center justify-center',
        day_button: cn(
          'h-9 w-9 rounded-md font-normal transition-colors',
          'hover:bg-primary/10 hover:text-primary',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          'aria-selected:opacity-100'
        ),
        selected:
          'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground rounded-md',
        today: 'bg-accent/20 text-accent-foreground font-semibold',
        outside: 'text-muted-foreground/30 aria-selected:bg-accent/50',
        disabled: 'text-muted-foreground/30 cursor-not-allowed',
        range_start:
          'bg-primary text-primary-foreground rounded-l-md rounded-r-none',
        range_end:
          'bg-primary text-primary-foreground rounded-r-md rounded-l-none',
        range_middle:
          'bg-primary/15 !text-primary rounded-none hover:bg-primary/20 hover:!text-primary',
        hidden: 'invisible',
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation }) => {
          return orientation === 'left' ? (
            <ChevronLeftIcon className="size-4" />
          ) : (
            <ChevronRightIcon className="size-4" />
          );
        },
      }}
      {...props}
    />
  );
}

export { Calendar };
